import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { KonstantesService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [KonstantesService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class KonstantesServiceModule {}
